import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapper from './AppWrapper'; // Changed from App to AppWrapper for mobile support
import reportWebVitals from './reportWebVitals';
import { API_ROOT } from "@/config";

// Comprehensive browser extension error handler
(function setupExtensionErrorHandler() {
  console.log('🛡️ Setting up browser extension error protection...');
  
  // Store original Object.defineProperty
  const originalDefineProperty = Object.defineProperty;
  
  // Override Object.defineProperty to handle extension conflicts
  Object.defineProperty = function(obj: any, prop: PropertyKey, descriptor: PropertyDescriptor) {
    try {
      return originalDefineProperty.call(this, obj, prop, descriptor);
    } catch (error: any) {
      if (error.message && error.message.includes('Cannot redefine property')) {
        console.warn('🛡️ Browser extension property conflict prevented:', String(prop));
        // Return the object unchanged instead of throwing
        return obj;
      }
      throw error;
    }
  };
  
  // Global error handler for extension conflicts
  window.addEventListener('error', function(event) {
    if (event.error && event.error.message) {
      const message = event.error.message;
      if (message.includes('Cannot redefine property') || 
          message.includes('defineProperty') ||
          event.filename?.includes('content.js') ||
          event.filename?.includes('extension')) {
        
        console.warn('🛡️ Browser extension error intercepted:', message);
        event.preventDefault();
        event.stopPropagation();
        return true;
      }
    }
  }, true); // Use capture phase
  
  // Handle promise rejections from extensions
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && event.reason.message) {
      const message = event.reason.message;
      if (message.includes('Cannot redefine property') || 
          message.includes('defineProperty')) {
        
        console.warn('🛡️ Browser extension promise rejection intercepted:', message);
        event.preventDefault();
        return true;
      }
    }
  });
  
  // Protect React globals
  const protectGlobal = (name: string) => {
    try {
      const existing = (window as any)[name];
      if (existing) {
        Object.defineProperty(window, name, {
          value: existing,
          writable: false,
          configurable: false
        });
      }
    } catch (e) {
      // Ignore if already protected
    }
  };
  
  // Protect critical globals
  ['React', '__REACT_DEVTOOLS_GLOBAL_HOOK__'].forEach(protectGlobal);
  
  console.log('🛡️ Browser extension error protection active');
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
